import { Navigate, Route, Routes } from 'react-router-dom'
import JoinLanding from '@/pages/join/JoinLanding'
import JoinApply from '@/pages/join/JoinApply'

/**
 * The recruitment site served on join.turksletloose.com.
 *
 * Same bundle and same nginx as the dashboard — only the hostname differs (see
 * App.tsx). It deliberately does not mount AuthProvider: applicants hold a
 * `tll_join` cookie, not a dashboard session, and /api/auth/me would 401 for
 * every visitor.
 */
export default function JoinApp() {
  return (
    <Routes>
      <Route path="/" element={<JoinLanding />} />
      <Route path="/apply" element={<JoinApply />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
